import { render, staticRenderFns } from "./IdentificationPhotos.vue?vue&type=template&id=d5f28a90"
import script from "./IdentificationPhotos.vue?vue&type=script&lang=js"
export * from "./IdentificationPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports